// extracted by mini-css-extract-plugin
export default {"main":"AIMarkingHeaders_main__h5Uof"};